<!-- Compiled at 2026-09-18T12:45:23.979Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<ng-container *ngIf="screen.request?.customerOffer"
					><mat-card>
						<mat-card-header>
							<mat-card-title
								><span
									[innerHtml]="'Offer parameters' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></mat-card-title>
						</mat-card-header>

						<mat-card-content>
							<div
								class="layout-block"
								[style.align-items]="'inherit'"
								[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[style.gap]="'1em'"
							>
								<mat-form-field
									class="has-selectionChange-handler"
									appearance="fill"
									(selectionChange)="handler_DropdownBlock_144_selectionChange_$adhoc_0($event, { $disabled: $disabled })"
								>
									@let $fc_144_1 = getFormControl(screen.request.customerOffer,
									'currency', 144, $scope, $formDirective, $disabled,
									$ignoreValidations);

									<mat-label
										[innerHtml]="'Offer currency' | escapeHtml"
									></mat-label>
									<mat-select
										class="has-selectionChange-handler"
										(selectionChange)="handler_DropdownBlock_144_selectionChange_$adhoc_0($event, { $disabled: $disabled })"
										[formControl]="$fc_144_1"
										[compareWith]="$compare"
										#select_144="matSelect"
										[lgFormComponent]="select_144"
										[lgFormValue]="screen.request.customerOffer.currency"
										canSelectNullableOptions
										[multiple]="false"
									>
										@let emptyOption_144 = null; @if (emptyOption_144) {
										<mat-option [value]="emptyOption_144[0]"
											>{{ emptyOption_144[1] }}</mat-option
										>
										}

										<mat-option
											*ngFor="let $option of (Orders.Currency.getChoices('$displayValue')); let $index = index"
											[value]="Orders.Currency.getEntry($option.id)"
										>
											<span
												[innerHtml]="$option.label | escapeHtml"
												style="margin: auto 0"
											></span>
										</mat-option>
									</mat-select>
								</mat-form-field>
								<mat-form-field
									*ngIf="$any(screen.request.customerOffer.currency)?.$isOther"
								>
									@let $fc_144_3 =
									getFormControl(screen.request.customerOffer.currency,
									'$otherValue', 144, $scope, $formDirective, $disabled,
									$ignoreValidations);
									<mat-label
										[innerHtml]="'Offer currency' + ' (Other)' | escapeHtml"
									></mat-label>
									<input type="text" matInput [formControl]="$fc_144_3" />
								</mat-form-field>

								<mat-form-field appearance="fill">
									@let $fc_146_1 = getFormControl(screen.request.customerOffer,
									'targetMarginPercentage', 146, $scope, $formDirective,
									$disabled, $ignoreValidations);
									<mat-label
										[innerHtml]="'Target margin' | escapeHtml"
									></mat-label>
									<input
										#input_146
										[formControl]="$fc_146_1"
										type="number"
										step="any"
										(dblclick)="$editInputValue($event.target)"
										matInput
									/>

									<span matTextSuffix
										><div
											class="layout-block"
											[style.align-items]="'inherit'"
											[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.gap]="'1em'"
										>
											<span
												[innerHtml]="'%' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
											<ng-container *ngIf="!$disabled"
												><ng-container
													*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.request.customerOffer.targetMarginPercentage == undefined)) as $disabled"
												>
													<a
														class="has-click-handler"
														(click)="handler_LinkBlock_142_click_$adhoc_0($event, { $disabled: $disabled })"
													>
														<mat-icon
															[innerHtml]="'send'"
															fontSet="material-icons"
															[inline]="false"
														></mat-icon>
													</a> </ng-container
											></ng-container></div
									></span>
								</mat-form-field>

								<mat-form-field appearance="fill">
									@let $fc_180_1 = getFormControl(screen.request.customerOffer,
									'targetDeliveryTimeWeeks', 180, $scope, $formDirective,
									$disabled, $ignoreValidations);
									<mat-label
										[innerHtml]="'Target delivery time' | escapeHtml"
									></mat-label>
									<input
										#input_180
										[formControl]="$fc_180_1"
										type="number"
										step="any"
										(dblclick)="$editInputValue($event.target)"
										matInput
									/>

									<span matTextSuffix
										><div
											class="layout-block"
											[style.align-items]="'inherit'"
											[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.gap]="'1em'"
										>
											<span
												[innerHtml]="'weeks' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
											<ng-container *ngIf="!$disabled"
												><ng-container
													*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(screen.request.customerOffer.targetDeliveryTimeWeeks == undefined)) as $disabled"
												>
													<a
														class="has-click-handler"
														(click)="handler_LinkBlock_184_click_$adhoc_0($event, { $disabled: $disabled })"
													>
														<mat-icon
															[innerHtml]="'send'"
															fontSet="material-icons"
															[inline]="false"
														></mat-icon>
													</a> </ng-container
											></ng-container></div
									></span>
								</mat-form-field>
							</div>
						</mat-card-content>
					</mat-card>
					<ng-container
						*ngFor="let item of screen.request.customerOffer.items; let itemIndex = index; trackBy: trackByAutomatic"
					>
						<ng-container *lowgileScope="item; as: 'item'; let $scope">
							<ng-container *lowgileScope="itemIndex; as: 'itemIndex'; let $scope">
								<mat-card>
									<mat-card-header>
										<mat-card-title
											><span
												[innerHtml]="`Offers for ${item.requestItem.name}` | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span
										></mat-card-title>
									</mat-card-header>

									<mat-card-content>
										<ng-container
											*ngFor="let quantity of item.quantities; let quantityIndex = index; trackBy: trackByAutomatic"
										>
											<ng-container
												*lowgileScope="quantity; as: 'quantity'; let $scope"
											>
												<ng-container
													*lowgileScope="quantityIndex; as: 'quantityIndex'; let $scope"
												>
													<mat-card>
														<mat-card-header>
															<mat-card-title
																><span
																	[innerHtml]="`${quantity.quantity} pieces` | escapeHtml: 'none' | replaceNewlines: 'span'"
																></span
															></mat-card-title>
														</mat-card-header>

														<mat-card-content>
															<lowgile-table
																#datatable_102
																[dataSignal]="_DataTableBlock_collectionCodeSignal_102(datatable_102, { app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex })"
																[trackBy]="trackByAutomatic"
																[columns]="_DataTableBlock_columns_102(screen)"
																[showSettings]="false"
																[userDefinedConfiguration]="undefined"
																[usePaging]="false"
																[pageSize]="999"
																[pageSizeOptions]="[10, 20, 50]"
																[useGlobalFilter]="false"
																[debouncingDelay]="250"
																[stickyHeader]="true"
																[additionalFindOptions]="_DataTableBlock_additionalFindOptions_102({ app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex })"
																[additionalHeaderRows]="[]"
																[additionalFooterRows]="[]"
																[allClasses]="$Modules"
																[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																[rowStyleFn]="_DataTableBlock_rowStyle_102"
																[surroundingScope]="$scope"
																#$table_102="lowgileTable"
															>
																<ng-container
																	[lowgile-column]="'vendor'"
																>
																	<th
																		mat-header-cell
																		*matHeaderCellDef
																	>
																		<span
																			[innerHtml]="'Vendor' | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																	</th>
																	<td
																		mat-cell
																		*matCellDef="let offer; let offerIndex = index"
																		[attr.data-label]="'Vendor'"
																	>
																		<ng-container
																			*lowgileScope="offer; as: 'offer'; let $scope"
																		>
																			<ng-container
																				*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
																			>
																				<span
																					[innerHtml]="_DataTableColumnBlock_cellText_107({ app, screen, $pathSegments, $disabled, item, itemIndex, quantity, quantityIndex, offer, offerIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
																				></span>
																			</ng-container>
																		</ng-container>
																	</td>
																</ng-container>
																<ng-container
																	[lowgile-column]="('vendor') + '$$filter'"
																>
																	<th
																		mat-header-cell
																		*matHeaderCellDef
																	></th>
																</ng-container>

																<ng-container
																	[lowgile-column]="'unitPrice'"
																>
																	<th
																		mat-header-cell
																		*matHeaderCellDef
																	>
																		<span
																			[innerHtml]="'Unit price' | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																	</th>
																	<td
																		mat-cell
																		*matCellDef="let offer; let offerIndex = index"
																		[attr.data-label]="'Unit price'"
																	>
																		<ng-container
																			*lowgileScope="offer; as: 'offer'; let $scope"
																		>
																			<ng-container
																				*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
																			>
																				@let offerQuantity =
																				_ScopeBlock_var_offerQuantity_153({
																				app, screen,
																				$pathSegments,
																				$disabled, item,
																				itemIndex, quantity,
																				quantityIndex,
																				offer, offerIndex
																				});
																				<ng-container
																					*lowgileScope="offerQuantity; as: 'offerQuantity'; let $scope"
																				>
																					<div
																						class="layout-block vertical"
																						[style.align-items]="'inherit'"
																						[style.gap]="'0.25em'"
																					>
																						<span
																							[innerHtml]="`${offer.currency.label} ${Sys.Text.formatAsCurrency(offerQuantity?.unitPrice)}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																						></span>
																						<ng-container
																							*ngIf="offer.discountPercent"
																							><span
																								[innerHtml]="`- ${offer.discountPercent}% = ${offer.currency.label} ${Sys.Text.formatAsCurrency(offerQuantity?.unitPriceDiscounted)}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																							></span
																						></ng-container>
																					</div>
																				</ng-container>
																			</ng-container>
																		</ng-container>
																	</td>
																</ng-container>
																<ng-container
																	[lowgile-column]="('unitPrice') + '$$filter'"
																>
																	<th
																		mat-header-cell
																		*matHeaderCellDef
																	></th>
																</ng-container>

																<ng-container
																	[lowgile-column]="'unitPriceReqCcy'"
																>
																	<th
																		mat-header-cell
																		*matHeaderCellDef
																	>
																		<span
																			[innerHtml]="`Unit price (${screen.request.customerOffer.currency.label})` | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																	</th>
																	<td
																		mat-cell
																		*matCellDef="let offer; let offerIndex = index"
																		[attr.data-label]="`Unit price (${screen.request.customerOffer.currency.label})`"
																	>
																		<ng-container
																			*lowgileScope="offer; as: 'offer'; let $scope"
																		>
																			<ng-container
																				*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
																			>
																				@let offerQuantity =
																				_ScopeBlock_var_offerQuantity_140({
																				app, screen,
																				$pathSegments,
																				$disabled, item,
																				itemIndex, quantity,
																				quantityIndex,
																				offer, offerIndex
																				});
																				<ng-container
																					*lowgileScope="offerQuantity; as: 'offerQuantity'; let $scope"
																				>
																					<div
																						class="layout-block vertical"
																						[style.align-items]="'inherit'"
																						[style.gap]="'0.25em'"
																					>
																						<span
																							[innerHtml]="`${screen.request.customerOffer.currency.label} ${Sys.Text.formatAsCurrency(offerQuantity.unitPriceCustomerCcy)}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																						></span>
																						<ng-container
																							*ngIf="!offerIndex"
																							><div
																								class="layout-block"
																								[style.align-items]="'inherit'"
																								[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																								[style.gap]="'0.5em'"
																							>
																								<mat-form-field
																									class="has-ngModelChange-handler"
																									appearance="fill"
																									(ngModelChange)="handler_InputBlock_133_ngModelChange_$adhoc_0($event, { item, itemIndex, quantity, quantityIndex, offer, offerIndex, offerQuantity, $disabled: $disabled })"
																								>
																									@let
																									$fc_133_1
																									=
																									getFormControl(quantity,
																									'margin',
																									133,
																									$scope,
																									$formDirective,
																									$disabled,
																									$ignoreValidations);
																									<mat-label
																										[innerHtml]="'Margin' | escapeHtml"
																									></mat-label>
																									<input
																										#input_133
																										[formControl]="$fc_133_1"
																										type="number"
																										step="any"
																										(dblclick)="$editInputValue($event.target)"
																										matInput
																										class="has-ngModelChange-handler"
																										(ngModelChange)="handler_InputBlock_133_ngModelChange_$adhoc_0($event, { item, itemIndex, quantity, quantityIndex, offer, offerIndex, offerQuantity, $disabled: $disabled })"
																										[required]="!$ignoreValidations"
																									/>

																									@for(error
																									of
																									$fc_133_1.errors
																									??
																									{}
																									|
																									keyvalue;
																									track
																									error.key)
																									{
																									<mat-error
																										*ngIf="typeof error.value == 'string'"
																										[innerHtml]="error.value | escapeHtml: 'safe'"
																									/>
																									}

																									<span
																										matTextSuffix
																										><span
																											[innerHtml]="screen.request.customerOffer.currency.label | escapeHtml: 'none' | replaceNewlines: 'span'"
																										></span
																									></span>
																									<mat-hint
																										><ng-container
																											*ngIf="quantity.margin != undefined"
																											><span
																												[innerHtml]="`${Sys.Math.roundToDigits(100 * quantity.margin / quantity.bestVendorOfferQuantity.unitPriceCustomerCcy, 0)} %` | escapeHtml: 'none' | replaceNewlines: 'span'"
																											></span
																										></ng-container>
																									</mat-hint>
																								</mat-form-field>

																								<mat-form-field
																									class="has-ngModelChange-handler"
																									appearance="fill"
																									(ngModelChange)="handler_InputBlock_134_ngModelChange_$adhoc_0($event, { item, itemIndex, quantity, quantityIndex, offer, offerIndex, offerQuantity, $disabled: $disabled })"
																								>
																									@let
																									$fc_134_1
																									=
																									getFormControl(quantity,
																									'unitPrice',
																									134,
																									$scope,
																									$formDirective,
																									$disabled,
																									$ignoreValidations);
																									<mat-label
																										[innerHtml]="'Offered price' | escapeHtml"
																									></mat-label>
																									<input
																										#input_134
																										[formControl]="$fc_134_1"
																										type="number"
																										step="any"
																										(dblclick)="$editInputValue($event.target)"
																										matInput
																										class="has-ngModelChange-handler"
																										(ngModelChange)="handler_InputBlock_134_ngModelChange_$adhoc_0($event, { item, itemIndex, quantity, quantityIndex, offer, offerIndex, offerQuantity, $disabled: $disabled })"
																										[required]="!$ignoreValidations"
																									/>

																									@for(error
																									of
																									$fc_134_1.errors
																									??
																									{}
																									|
																									keyvalue;
																									track
																									error.key)
																									{
																									<mat-error
																										*ngIf="typeof error.value == 'string'"
																										[innerHtml]="error.value | escapeHtml: 'safe'"
																									/>
																									}

																									<span
																										matTextSuffix
																										><span
																											[innerHtml]="screen.request.customerOffer.currency.label | escapeHtml: 'none' | replaceNewlines: 'span'"
																										></span
																									></span>
																								</mat-form-field></div
																						></ng-container>
																					</div>
																				</ng-container>
																			</ng-container>
																		</ng-container>
																	</td>
																</ng-container>
																<ng-container
																	[lowgile-column]="('unitPriceReqCcy') + '$$filter'"
																>
																	<th
																		mat-header-cell
																		*matHeaderCellDef
																	></th>
																</ng-container>

																<ng-container
																	[lowgile-column]="'deliveryTime'"
																>
																	<th
																		mat-header-cell
																		*matHeaderCellDef
																	>
																		<span
																			[innerHtml]="'Delivery time' | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																	</th>
																	<td
																		mat-cell
																		*matCellDef="let offer; let offerIndex = index"
																		[attr.data-label]="'Delivery time'"
																	>
																		<ng-container
																			*lowgileScope="offer; as: 'offer'; let $scope"
																		>
																			<ng-container
																				*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
																			>
																				<div
																					class="layout-block vertical"
																					[style.align-items]="'inherit'"
																					[style.gap]="'0.25em'"
																				>
																					<span
																						[innerHtml]="offer.getItemForReqItem(item.requestItemId)?.getQuantity(quantity.quantity)?.deliveryTime | escapeHtml: 'none' | replaceNewlines: 'span'"
																					></span>
																					<ng-container
																						*ngIf="!offerIndex"
																						><mat-form-field
																							appearance="fill"
																						>
																							@let
																							$fc_137_1
																							=
																							getFormControl(quantity,
																							'deliveryTimeWeeks',
																							137,
																							$scope,
																							$formDirective,
																							$disabled,
																							$ignoreValidations);
																							<mat-label
																								[innerHtml]="'Delivery time' | escapeHtml"
																							></mat-label>
																							<input
																								#input_137
																								[formControl]="$fc_137_1"
																								type="number"
																								step="any"
																								(dblclick)="$editInputValue($event.target)"
																								matInput
																								[required]="!$ignoreValidations"
																							/>

																							@for(error
																							of
																							$fc_137_1.errors
																							?? {} |
																							keyvalue;
																							track
																							error.key)
																							{
																							<mat-error
																								*ngIf="typeof error.value == 'string'"
																								[innerHtml]="error.value | escapeHtml: 'safe'"
																							/>
																							}

																							<span
																								matTextSuffix
																								><span
																									[innerHtml]="'weeks' | escapeHtml: 'none' | replaceNewlines: 'span'"
																								></span
																							></span>
																						</mat-form-field>
																					</ng-container>
																				</div>
																			</ng-container>
																		</ng-container>
																	</td>
																</ng-container>
																<ng-container
																	[lowgile-column]="('deliveryTime') + '$$filter'"
																>
																	<th
																		mat-header-cell
																		*matHeaderCellDef
																	></th>
																</ng-container>
															</lowgile-table>
														</mat-card-content>
													</mat-card>
												</ng-container>
											</ng-container>
										</ng-container>
									</mat-card-content>
								</mat-card>
							</ng-container>
						</ng-container>
					</ng-container>
					<mat-card>
						<mat-card-header>
							<mat-card-title
								><span
									[innerHtml]="'Offer document (manually created in ERP)' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></mat-card-title>
						</mat-card-header>

						<mat-card-content>
							<div
								class="layout-block"
								[style.align-items]="'inherit'"
								[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[style.--layout-column-count]="2"
								[style.gap]="'1em'"
							>
								<div
									class="layout-block"
									[style.grid-column]="'span ' + (1)"
									[style.align-items]="'inherit'"
									[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.gap]="'1em'"
								>
									<ng-container
										*ngIf="screen.request.customerOffer.offerFileId; else else179"
										><ng-container
											*ngrxLet="(!devBarService.isEnableEverything()) && (!!(false)) as $disabled"
										>
											<button
												mat-raised-button
												color="basic"
												[disabled]="$disabled"
											>
												<mat-icon>{{'download'}}</mat-icon
												><span
													[innerHtml]="screen.request.customerOffer.offerFilename | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</button> </ng-container
									></ng-container>
									<ng-template #else179>
										<ng-container *ngIf="!$disabled"
											><app-file-upload
												class="has-filesSelected-handler"
												(filesSelected)="handler_FileUploadBlock_177_filesSelected_$adhoc_0($event, { $disabled: $disabled })"
												[multiple]="false"
												[allowedMimeTypes]="'application/pdf'"
												[disabled]="$disabled"
												displayStyle="dropZone"
												[uploadToServer]="false"
												color="basic"
											>
												<span
													[innerHtml]="'Drop offer PDF here to upload' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span> </app-file-upload
										></ng-container>
									</ng-template>
									<ng-container
										*ngIf="screen.request.customerOffer?.offerFilename && !$disabled"
										><a
											class="has-click-handler"
											(click)="handler_LinkBlock_189_click_$adhoc_0($event, { $disabled: $disabled })"
										>
											<mat-icon
												[innerHtml]="'delete'"
												fontSet="material-icons"
												[inline]="false"
											></mat-icon> </a
									></ng-container>
								</div>
								<div
									class="layout-block vertical"
									[style.grid-column]="'span ' + (1)"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<span
										[innerHtml]="'E-mail reply text:' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>

									@let $fc_199_1 = getFormControl(screen.request.customerOffer,
									'emailText', 199, $scope, $formDirective, $disabled,
									$ignoreValidations);
									<div>
										<lowgile-rich-text-editor [formControl]="$fc_199_1" />
										<div
											style="color: var(--mat-form-field-error-text-color)"
										></div>
									</div>
								</div>
							</div>
						</mat-card-content> </mat-card
				></ng-container>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
